module.exports = __webpack_public_path__ + "img/SAMATEL.69c62c60.svg";